(function () {
  if (window.dsFooterOverlays) return;
  window.dsFooterOverlays = true;

  var footer;
  var observer;
  var hidden = false;
  var chatApi;
  var dialogs = new WeakSet();
  var closedButtons = new WeakSet();
  var popupObserver = new MutationObserver(closeKlaviyoPopups);

  function closeKlaviyoPopups() {
    if (!hidden) return;
    document.querySelectorAll('[role="dialog"][class*="kl-private-reset-css"]').forEach(function (dialog) {
      if (!dialogs.has(dialog)) {
        dialogs.add(dialog);
        popupObserver.observe(dialog, { attributes: true, attributeFilter: ['style', 'aria-hidden'] });
      }
      var button = dialog.querySelector('button.klaviyo-close-form');
      if (!button) return;
      if (dialog.style.animationName === 'klaviyo-fadeout') {
        document.body.classList.remove('klaviyo-prevent-body-scrolling');
        return;
      }
      if (dialog.style.display === 'none' || dialog.getAttribute('aria-hidden') === 'true') {
        closedButtons.delete(button);
        return;
      }
      if (closedButtons.has(button)) return;
      closedButtons.add(button);
      button.click();
    });
  }

  function closeChat() {
    if (hidden && chatApi && chatApi.isOpen()) chatApi.close();
  }

  function setHidden(value) {
    if (hidden === value) return;
    hidden = value;
    document.body.classList.toggle('ds-footer-overlays-hidden', hidden);
    if (hidden) {
      popupObserver.observe(document.body, { childList: true, subtree: true });
      closeKlaviyoPopups();
      closeChat();
    } else {
      popupObserver.disconnect();
      dialogs = new WeakSet();
      closedButtons = new WeakSet();
    }
  }

  function update() {
    var rect = footer && footer.isConnected && footer.getBoundingClientRect();
    setHidden(!!rect && rect.top < window.innerHeight && rect.bottom > 0);
  }

  function connect() {
    if (observer) observer.disconnect();
    footer = document.querySelector('.site-footer');
    if (footer && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(update);
      observer.observe(footer);
    }
    update();
  }

  function initChat() {
    if (!window.GorgiasChat || !window.GorgiasChat.init) return;
    window.GorgiasChat.init().then(function () {
      chatApi = window.GorgiasChat;
      closeChat();
    }).catch(function () {});
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('pageshow', update);
  window.addEventListener('gorgias-widget-loaded', initChat);
  document.addEventListener('shopify:section:load', connect);
  connect();
  initChat();
})();
